// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../static/images/index-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../static/images/home1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../static/images/home2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../static/images/home3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../static/images/home4.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  text-decoration: none;
}
.indexBanner {
  text-align: center;
  background: #f5f5f5;
  min-width: 1200px;
}
.homeBanner {
  height: 430px;
  min-width: 1200px;
  background: #e1e8f2 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat top center;
}
.homeBanner .textBox {
  width: 1200px;
  margin: 0px auto;
  padding-top: 150px;
}
.homeBanner .textBox h2 {
  font-size: 36px;
  line-height: 50px;
  margin: 0px;
  color: #333;
}
.homeBanner .textBox h3 {
  font-size: 20px;
  line-height: 50px;
  color: #5d77aa;
  margin: 0px;
}
.titleBox {
  width: 100%;
  padding-top: 40px;
  padding-bottom: 30px;
}
.titleBox .con {
  width: 1200px;
  margin: 0px auto;
}
.titleBox .con::after {
  content: '';
  display: block;
  width: 80px;
  height: 5px;
  background: #5595eb;
}
.titleBox span {
  font-size: 40px;
  color: #f0f0f0;
  font-weight: bold;
}
.titleBox h3 {
  font-size: 34px;
  color: #333;
  margin: 0px;
  padding: 0px;
  margin-top: -35px;
  margin-bottom: 5px;
}
.hexin {
  width: 1200px;
  margin: 0px auto;
  padding-bottom: 40px;
}
.hexin ul {
  display: flex;
  flex-wrap: wrap;
}
.hexin ul li {
  width: calc(50% - 5px);
  height: 260px;
  margin-bottom: 10px;
  padding: 0px 20px;
  box-sizing: border-box;
}
.hexin ul li h3 {
  padding-top: 20px;
}
.hexin ul li .list {
  display: flex;
  flex-wrap: wrap;
  line-height: 35px;
  height: 70px;
  padding-bottom: 40px;
}
.hexin ul li .list span {
  min-width: 30%;
  padding: 0px;
  font-size: 16px;
  color: #666;
}
.hexin ul li:first-child {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  margin-right: 10px;
}
.hexin ul li:nth-of-type(2) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.hexin ul li:nth-of-type(3) {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  margin-right: 10px;
}
.hexin ul li:last-child {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.hexin ul a {
  color: #0052d9;
  font-size: 14px;
  border: 1px solid #0052d9;
  border-radius: 3px;
  line-height: 30px;
  background: #fff;
  display: inline-block;
  padding: 0px 15px;
}
.jiagou {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  background: #f2f5fa;
}
.jiagou-con {
  width: 1200px;
  margin: 0px auto;
  padding-bottom: 60px;
  padding-top: 10px;
}
.jiagou-con img {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/index.less"],"names":[],"mappings":"AAAA;EAAE,qBAAA;AAEF;AADA;EAAa,kBAAA;EAAoB,mBAAA;EAAqB,iBAAA;AAMtD;AALA;EAAY,aAAA;EAAc,iBAAA;EAAkB,gFAAA;AAU5C;AAVA;EACY,aAAA;EAAc,gBAAA;EAAiB,kBAAA;AAc3C;AAfA;EAES,eAAA;EAAgB,iBAAA;EAAkB,WAAA;EAAY,WAAA;AAmBvD;AArBA;EAGS,eAAA;EAAgB,iBAAA;EAAiB,cAAA;EAAe,WAAA;AAwBzD;AArBA;EAAU,WAAA;EAAY,iBAAA;EAAkB,oBAAA;AA0BxC;AA1BA;EACQ,aAAA;EAAc,gBAAA;AA6BtB;AA9BA;EAEe,WAAA;EAAa,cAAA;EAAgB,WAAA;EAAY,WAAA;EAAY,mBAAA;AAmCpE;AArCA;EAGQ,eAAA;EAAgB,cAAA;EAAe,iBAAA;AAuCvC;AA1CA;EAIM,eAAA;EAAiB,WAAA;EAAY,WAAA;EAAa,YAAA;EAAa,iBAAA;EAAkB,kBAAA;AA8C/E;AA5CA;EAAO,aAAA;EAAc,gBAAA;EAAiB,oBAAA;AAiDtC;AAjDA;EACM,aAAA;EAAe,eAAA;AAoDrB;AArDA;EAES,sBAAA;EAAuB,aAAA;EAAc,mBAAA;EAAoB,iBAAA;EAAkB,sBAAA;AA0DpF;AA5DA;EAGY,iBAAA;AA4DZ;AA/DA;EAIe,aAAA;EAAe,eAAA;EAAiB,iBAAA;EAAkB,YAAA;EAAa,oBAAA;AAkE9E;AAtEA;EAKiB,cAAA;EAAe,YAAA;EAAa,eAAA;EAAgB,WAAA;AAuE7D;AA5EA;EAQqB,mDAAA;EAAgD,kBAAA;AAwErE;AAhFA;EASwB,mDAAA;AA0ExB;AAnFA;EAUwB,mDAAA;EAAgD,kBAAA;AA6ExE;AAvFA;EAWoB,mDAAA;AA+EpB;AA1FA;EAaS,cAAA;EAAe,eAAA;EAAgB,yBAAA;EAA0B,kBAAA;EAAmB,iBAAA;EAAkB,gBAAA;EAC9F,qBAAA;EAAuB,iBAAA;AAsFhC;AAlFA;EAAQ,WAAA;EAAY,iBAAA;EAAkB,gBAAA;EAAiB,mBAAA;AAwFvD;AAvFG;EAAM,aAAA;EAAc,gBAAA;EAAiB,oBAAA;EAAsB,iBAAA;AA6F9D;AA7FG;EACO,WAAA;AA+FV","sourcesContent":["a{text-decoration: none;}\n.indexBanner{text-align: center; background: #f5f5f5; min-width:1200px;}\n.homeBanner{height:430px; min-width:1200px; background:#e1e8f2 url(../../static/images/index-banner.jpg) no-repeat top center;\n   .textBox{width:1200px; margin:0px auto; padding-top:150px;\n      h2{font-size:36px; line-height:50px; margin:0px; color:#333}\n      h3{font-size:20px; line-height:50px;color:#5d77aa; margin:0px;}\n   }\n}\n.titleBox{width:100%; padding-top:40px; padding-bottom:30px;\n   .con{width:1200px; margin:0px auto;   }\n   .con::after{content: ''; display: block; width:80px; height:5px; background:#5595eb;}\n   span{font-size:40px; color:#f0f0f0; font-weight: bold; }\n   h3{font-size: 34px; color:#333; margin: 0px; padding:0px; margin-top:-35px; margin-bottom:5px;}\n}\n.hexin{width:1200px; margin:0px auto; padding-bottom:40px;\n   ul{display: flex; flex-wrap: wrap;\n      li{width:calc(50% - 5px); height:260px; margin-bottom:10px; padding:0px 20px; box-sizing: border-box;\n         h3{padding-top:20px;}\n         .list{display: flex; flex-wrap: wrap; line-height:35px; height:70px; padding-bottom:40px;\n            span{min-width:30%; padding:0px; font-size:16px; color:#666;}\n         }\n      }\n      li:first-child{background: url(../../static/images/home1.png); margin-right: 10px;}\n      li:nth-of-type(2){background: url(../../static/images/home2.png);}\n      li:nth-of-type(3){background: url(../../static/images/home3.png); margin-right: 10px;}\n      li:last-child{background: url(../../static/images/home4.png);}\n      a{\n         color:#0052d9; font-size:14px; border:1px solid #0052d9; border-radius:3px; line-height:30px; background:#fff;\n         display: inline-block; padding:0px 15px;\n      }\n   }\n}\n.jiagou{width:100%; min-width:1200px; margin:0px auto; background:#f2f5fa;\n   &-con{width:1200px; margin:0px auto; padding-bottom:60px;  padding-top:10px;\n      img{width:100%;}\n   }\n   \n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
